import React, { useEffect, useState, Suspense } from 'react'
import { getUser } from '../../users/actions/user'
import _ from 'lodash'
import { countryIds } from '../../../components/_utils/appUtils'

const MeetingRecordGraph = React.lazy(() => import('../components/meetingRecordGraph'))
const ExpenseRecordGraph = React.lazy(() => import('../components/expenseRecordGraph'))
const TopAgentVisaRecordGraph = React.lazy(() => import('../components/topAgentVisaRecordGraph'))
const StateWiseRecords = React.lazy(() => import('../components/stateWiseRecords'))
const CountryWiseReportComponent = React.lazy(() => import('../marketingUserComponents/countryWiseReportComponent'))
const MarketingUserInfo = React.lazy(() => import('../components/marketingUserInfo'))
const UkStudentYearWise = React.lazy(() => import('../../dashboard/components/UkStudentYearWise'))

const MarketingUserDashboard = (props) => {
  let { dispatch } = props
  let [showUkStudentGraph, setShowUkStudentGraph] = useState(false)
  let user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null
  let [currentUserId, setCurrentUserId] = useState('')
  useEffect(() => {
    loadUrl()
  }, [])
  let loadUrl = () => {
    let searchParams = new URLSearchParams(window.location.search)
    let userId = searchParams.get('id')
    if (userId) {
      setCurrentUserId(userId)
    }
  }

  useEffect(() => {
    loadUserData()
  }, [currentUserId])

  const loadUserData = async () => {
    let userId = user._id
    if (currentUserId) {
      userId = currentUserId
    }
    let data = await dispatch(getUser(userId))
    if (data && data._id) {
      let findUk = _.find(data.marketingCountries, (item) => {
        return item && item.countryId && item.countryId._id && item.countryId._id.toString() == countryIds.uk
      })
      if (findUk && findUk.countryId) {
        setShowUkStudentGraph(true)
      }
    }
  }

  return (
    <>
      <div key={currentUserId}>
        <Suspense fallback={<></>}>
          <MarketingUserInfo userId={currentUserId ? currentUserId : user._id} />
        </Suspense>

        {showUkStudentGraph ? <Suspense fallback={<></>}>
          <div className={'mt20'}>
            <UkStudentYearWise />
          </div>
        </Suspense> : null}

        <Suspense fallback={<></>}>
          <CountryWiseReportComponent currentUserId={currentUserId} />
        </Suspense>

        <Suspense fallback={<></>}>
          <MeetingRecordGraph currentUserId={currentUserId} />
        </Suspense>

        <Suspense fallback={<></>}>
          <ExpenseRecordGraph currentUserId={currentUserId} />
        </Suspense>

        <Suspense fallback={<></>}>
          <TopAgentVisaRecordGraph currentUserId={currentUserId} />
        </Suspense>

        <Suspense fallback={<></>}>
          <StateWiseRecords currentUserId={currentUserId} />
        </Suspense>

      </div>
    </>
  )
}
export default MarketingUserDashboard
